import getDetailedLeaderboardList from './utils/getDetailedLeaderboardList';
import { TournamentFragment } from '@/shared/graphql/TournamentFragment.generated';

const useLeaderboardList = (tournament?: TournamentFragment) => {
  const [initialList, listWithUser] = getDetailedLeaderboardList(
    tournament?.myScore,
    tournament?.leaderboard,
  );

  return { initialList, listWithUser };
};

export default useLeaderboardList;
